import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_DELETE_CUSTOM_FIELDS_SERVER } from '@/app/module/custom-fields/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useDeleteCustomField = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [deleteCustomField, res] = esApi.endpoints.deleteOrgCustomfield.useMutation()

  const deleteCustomFieldById = useCallback(
    async (customfieldId: string, name: string) => {
      try {
        const result = await deleteCustomField({
          orgId: orgId.toString(),
          customfieldId,
        }).unwrap()

        dispatch(
          createNotification({
            'delete-custom-field-success': {
              type: 'success',
              message: `Custom field "${name}" was successfully deleted`,
            },
          }),
        )

        return result
      } catch {
        dispatch(
          createNotification({
            'delete-custom-field-failure': {
              type: 'error',
              message: ERROR_DELETE_CUSTOM_FIELDS_SERVER,
            },
          }),
        )

        return undefined
      }
    },
    [orgId, dispatch, deleteCustomField],
  )

  return [deleteCustomFieldById, res] as const
}
